export const PRODUCT_GASLESS_MINTING_INFORMATION = {
  title: "Mint NFTs Without the Gas Fees",
  highlight: "Without the Gas Fees",
  description:
    "Experience the world’s first and only gasless minting technology, exclusively from Mintology. Instantly create NFTs without crypto wallet setups or unpredictable transaction costs. Unlock massive scalability and next-gen engagement for your business – all without the gas pain.",
  image: "/images/products/gasless-hero-image.webp",
  imageInfo: "Hero image for Mintology Gasless Minting page",
  bgImage: false,
  buttonText: "Mint NFT Now!",
};
export const PRODUCT_GASLESS_MINTING_OFFERING = {
  title: "Say Goodbye to Gas Fee Headaches",
  highlight: "Gas Fee Headaches",
  description:
    "Gas fees are killing NFT adoption, but Mintology fixes that. We remove every friction point so you can focus on scaling your business, not explaining gas prices to users.",
  offerings: [
    {
      icon: (
        <img
          alt="cost-conversion"
          src={"/icons/cost-conversion.svg"}
          className="w-16 h-10"
        />
      ),
      title: "High Costs, Low Conversion",
      description:
        "Traditional NFT minting forces users to pay unpredictable, sky-high gas fees. Most bounce before completing checkout. Mintology’s gasless tech removes the cost barrier, making NFT creation seamless and boosting your conversion rates.",
    },
    {
      icon: (
        <img
          alt="wallet-confusion"
          src={"/icons/wallet-confusion.svg"}
          className="w-16 h-10"
        />
      ),
      title: "Crypto Wallet Confusion",
      description:
        "Gas fees usually mean users need a crypto wallet just to mint. That’s a massive drop-off point. Mintology’s solution lets users mint instantly — no setup barriers, no crypto, no drama.",
    },
    {
      icon: (
        <img
          alt="scalability-limits"
          src={"/icons/scalability-limits.svg"}
          className="w-16 h-10"
        />
      ),
      title: "Scalability Limits",
      description:
        "Scaling your NFT project to thousands (or millions) of users? Gas fees rack up fast. Mintology’s proprietary gasless tech lets you scale effortlessly while staying cost-efficient.",
    },
  ],
};

export const PRODUCT_GASLESS_MINTING_KEY_FEATURES = {
  title: "Inside the World’s Most Advanced Gasless Minting Platform",
  highlight: "World’s Most Advanced",
  description:
    "Mintology’s proprietary gasless technology makes NFT creation faster, easier, and more accessible – without hidden costs or technical roadblocks. We’re the only provider globally offering true gasless minting at scale, trusted by enterprises and brands worldwide.",
  features: [
    {
      attribute: "Revolutionary",
      title: "True Gasless Experience",
      description:
        "No gas fees for users, no hidden costs for businesses. Mint NFTs seamlessly without ever touching crypto.",
    },
    {
      attribute: "Scalable",
      title: "Enterprise-Grade Scalability",
      description:
        "Mint thousands (or millions) of NFTs without worrying about congestion, speed, or reliability.",
    },
    {
      attribute: "Compliant",
      title: "Advanced Security and Compliance",
      description:
        "We prioritize security at every step, with full KYC/AML support and GDPR-compliant operations, so you can mint with confidence.",
    },
    {
      attribute: "Branded",
      title: "Full Brand Control",
      description:
        "Keep the entire minting flow on-brand. Customizable UX, white-label options, and full ownership of the customer journey.",
    },
    {
      attribute: "Dynamic",
      title: "Built for Web2 and Web3",
      description:
        "Whether you’re Web2-native or fully Web3, our APIs and no-code tools fit right into your existing platforms.",
    },
    {
      attribute: "Friendly",
      title: "Seamless User Experience",
      description:
        "No wallet setups, no crypto jargon. Users mint in a few clicks, just like they’re signing up for any regular web app.",
    },
  ],
};

export const PRODUCT_GASLESS_MINTING_BRAND_ENGAGEMENT = {
  title: "Unlock New Revenue Streams and Amplify Brand Engagement",
  highlight: "New Revenue Streams",
  titleHeight: 100,
  revenue_streams: [
    {
      image: "/images/products/nft-campaign-image.png",
      title: "Launch Unlimited NFT Campaigns",
      description:
        "With Mintology's gasless technology, brands can deploy NFT campaigns at scale: loyalty rewards, exclusive merchandise, or limited-edition collectibles. All without the burden of transaction fees.​",
    },
    {
      image: "/images/products/membership-and-rewards-image.png",
      title: "Create Exclusive Memberships and Rewards",
      description:
        "Transform your customer base into a loyal community. Effortlessly mint NFT-based memberships, badges, or rewards that grant users VIP access, early product releases, or special privileges.",
    },
    {
      image: "/images/products/business-model-image.png",
      title: "Power New Business Models",
      description:
        "Seize innovative revenue opportunities with ease. Whether it's subscription-based NFTs, dynamic digital assets, or earning royalties from secondary sales, Mintology's gasless platform enables scalable and profitable business models without friction.",
    },
  ],
};

export const PRODUCT_GASLESS_MINTING_USE_CASES = {
  title: "Gasless Minting Across Industries",
  highlight: "Gasless Minting",
  image: "/images/products/gasless-minting-use-case-image.webp",
  useCases: [
    {
      title: "Art and Music",
      description:
        "Artists and musicians can effortlessly tokenize their creations, offering fans unique digital collectibles without the hassle of gas fees.​",
    },
    {
      title: "Metaverse",
      description:
        "Virtual worlds can tokenize properties and assets, allowing users to buy, sell, or trade digital real estate without incurring gas fees. ​​ ​",
    },
    {
      title: "Gaming",
      description:
        "Game developers can introduce in-game assets as NFTs, enhancing player engagement through seamless, gas-free transactions.​",
    },
    {
      title: "Community Building",
      description:
        "Brands and influencers can distribute NFTs as rewards, fostering deeper connections with their audience through exclusive, gasless digital assets.​",
    },
  ],
};

export const PRODUCT_GASLESS_MINTING_REASON = {
  title: "Why Your Business Needs Gasless Minting",
  highlight: "Gasless Minting",
  description:
    "Open doors to new opportunities and upscale your digital strategy by incorporating gasless minting: a simplified way to create and manage NFTs without the hassle of transaction fees.",
  reasons: [
    {
      title: "Expand Your Digital Offerings",
      description:
        "Integrate NFT technology into your business model without the complexities of gas fees, opening up new avenues for digital product offerings.​​",
    },
    {
      title: "Enhance Customer Loyalty",
      description:
        "Reward your customers with exclusive, gas-free NFTs, fostering deeper engagement and long-term loyalty.​",
    },
    {
      title: "Streamline Operations",
      description:
        "Simplify your digital asset management with our user-friendly platform, reducing operational overhead and enhancing efficiency.",
    },
  ],
};

export const PRODUCT_GASLESS_MINTING_CTA = {
  title: "Skyrocket Your Business Growth With Gasless Minting",
  highlight: "Skyrocket Your Business",
  buttonText: "Mint NFT Now!",
};
export const PRODUCT_GASLESS_MINTING_INTEGRATION = {
  title: "Plug & Play Gasless Minting: APIs Built for Your Stack",
  highlight: "APIs Built for Your Stack",
  description:
    "Mintology’s powerful APIs plug into your existing apps, CMS, or backend. From trait logic to minting and metadata updates, control every aspect of your generative NFT pipeline with a few lines of code.",
};
